import { render, staticRenderFns } from "./BoxDeletingModal.vue?vue&type=template&id=1b98c8b6&"
import script from "./BoxDeletingModal.vue?vue&type=script&lang=ts&"
export * from "./BoxDeletingModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports